import type { ReactElement } from 'react';

import useHasUnreadWhatsNew from '../hooks/useHasUnreadWhatsNew';

export default function WhatsNewDot(): ReactElement | null {
  const hasUnread = useHasUnreadWhatsNew();

  if (!hasUnread) return null;

  return (
    <span className="vtwo:flex vtwo:size-[15px] vtwo:shrink-0 vtwo:items-center vtwo:justify-center">
      <span
        className="vtwo:size-2 vtwo:rounded-full vtwo:bg-linear-to-r vtwo:from-[#8244ba] vtwo:to-[#206b9f]"
        role="status"
        aria-label="New announcements"
      />
    </span>
  );
}
